<template>
    <div
        class="faq-container"
        :class="{ 'mt-160': mt160, 'faq-page': faqPage }"
    >
        <div class="title-containers">
            <div class="subtitle">{{ $t("faq.subtitle") }}</div>
            <h2 class="title">{{ title }}</h2>
        </div>
        <template v-if="type == '' || type == 'documents'">
            <h4 class="faq-title">{{ $t("faq.list.document.title") }}</h4>
            <div
                class="-item"
                @click="collapseDocActive(index)"
                v-for="(faq, index) in documents"
                :key="'document_' + index"
            >
                <div class="-question" :id="'doc-' + index">
                    <span class="collapse-title">{{ faq.title }}</span>
                </div>
                <div class="-answer">
                    <span class="text" v-html="faq.text" />
                </div>
            </div>
        </template>

        <template v-if="type == '' || type == 'offers'">
            <h4 class="faq-title">{{ $t("faq.list.offers.title") }}</h4>
            <div
                class="-item"
                @click="collapseOfferActive(index)"
                v-for="(faq, index) in offers"
                :key="'offers_' + index"
            >
                <template>
                    <div class="-question" :id="'offer-' + index">
                        <span class="collapse-title">{{ faq.title }}</span>
                    </div>
                    <div class="-answer">
                        <span class="text" v-html="faq.text" />
                    </div>
                </template>
            </div>
        </template>

        <template v-if="type == '' || type == 'command'">
            <h4 class="faq-title">{{ $t("faq.list.command.title") }}</h4>
            <div
                class="-item"
                @click="collapseCommandActive(index)"
                v-for="(faq, index) in command"
                :key="'command_' + index"
            >
                <template>
                    <div class="-question" :id="'command-' + index">
                        <span class="collapse-title">{{ faq.title }}</span>
                    </div>
                    <div class="-answer">
                        <span class="text" v-html="faq.text" />
                    </div>
                </template>
            </div>
        </template>

        <template v-if="type == '' || type == 'payment'">
            <h4 class="faq-title">{{ $t("faq.list.payment.title") }}</h4>
            <div
                class="-item"
                @click="collapsePaymentActive(index)"
                v-for="(faq, index) in payment"
                :key="'payment_' + index"
            >
                <template>
                    <div class="-question" :id="'payment-' + index">
                        <span class="collapse-title">{{ faq.title }}</span>
                    </div>
                    <div class="-answer">
                        <span class="text" v-html="faq.text" />
                    </div>
                </template>
            </div>
        </template>

        <div class="slot-container">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        mt160: {
            type: Boolean,
            default: false,
        },
        faqPage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            documents: [
                {
                    type: "documents",
                    title: this.$t("faq.list.document.faq1.title"),
                    text: this.$t("faq.list.document.faq1.text"),
                },
                {
                    type: "documents",
                    title: this.$t("faq.list.document.faq2.title"),
                    text: this.$t("faq.list.document.faq2.text"),
                },

                {
                    type: "documents",
                    title: this.$t("faq.list.document.faq3.title"),
                    text: this.$t("faq.list.document.faq3.text"),
                },
                {
                    type: "documents",
                    title: this.$t("faq.list.document.faq4.title"),
                    text: this.$t("faq.list.document.faq4.text"),
                },
                {
                    type: "documents",
                    title: this.$t("faq.list.document.faq5.title"),
                    text: this.$t("faq.list.document.faq5.text"),
                },
                {
                    type: "documents",
                    title: this.$t("faq.list.document.faq6.title"),
                    text: this.$t("faq.list.document.faq6.text"),
                },
                {
                    type: "documents",
                    title: this.$t("faq.list.document.faq7.title"),
                    text: this.$t("faq.list.document.faq7.text"),
                },
                {
                    type: "documents",
                    title: this.$t("faq.list.document.faq8.title"),
                    text: this.$t("faq.list.document.faq8.text"),
                },

                {
                    type: "documents",
                    title: this.$t("faq.list.document.faq9.title"),
                    text: this.$t("faq.list.document.faq9.text"),
                },
            ],
            offers: [
                // OFFRES THE ORIGINALS RENAULT SERVICES
                {
                    type: "offers",
                    title: this.$t("faq.list.offers.faq1.title"),
                    text: this.$t("faq.list.offers.faq1.text"),
                },
                {
                    type: "offers",
                    title: this.$t("faq.list.offers.faq2.title"),
                    text: this.$t("faq.list.offers.faq2.text"),
                },
            ],
            command: [
                // COMMANDE ET LIVRAISON
                {
                    type: "command",
                    title: this.$t("faq.list.command.faq1.title"),
                    text: this.$t("faq.list.command.faq1.text"),
                },
                {
                    type: "command",
                    title: this.$t("faq.list.command.faq2.title"),
                    text: this.$t("faq.list.command.faq2.text"),
                },
                {
                    type: "command",
                    title: this.$t("faq.list.command.faq3.title"),
                    text: this.$t("faq.list.command.faq3.text"),
                },
                {
                    type: "command",
                    title: this.$t("faq.list.command.faq4.title"),
                    text: this.$t("faq.list.command.faq4.text"),
                },
            ],
            payment: [
                // PAIEMENT
                {
                    type: "payment",
                    title: this.$t("faq.list.payment.faq1.title"),
                    text: this.$t("faq.list.payment.faq1.text"),
                },
                {
                    type: "payment",
                    title: this.$t("faq.list.payment.faq2.title"),
                    text: this.$t("faq.list.payment.faq2.text"),
                },
                {
                    type: "payment",
                    title: this.$t("faq.list.payment.faq3.title"),
                    text: this.$t("faq.list.payment.faq3.text"),
                },
                {
                    type: "payment",
                    title: this.$t("faq.list.payment.faq4.title"),
                    text: this.$t("faq.list.payment.faq4.text"),
                },
                {
                    type: "payment",
                    title: this.$t("faq.list.payment.faq5.title"),
                    text: this.$t("faq.list.payment.faq5.text"),
                },
            ],
        };
    },
    methods: {
        collapseDocActive(id) {
            const collapseActive = document.querySelector(`#doc-${id}`);
            const collapsesHidden = document.querySelectorAll(".-question");
            const collapseParentActive = document.querySelector(
                `#doc-${id}`
            ).parentElement;

            collapsesHidden.forEach((element) => {
                if (!element.classList.contains("hidden"))
                    element.classList.add("hidden");
            });

            if (!collapseParentActive.classList.contains("active")) {
                collapseParentActive.classList.add("active");
                collapseActive.classList.remove("hidden");
            } else {
                collapseParentActive.classList.remove("active");
                collapseActive.classList.add("hidden");
            }
        },

        collapseOfferActive(id) {
            const collapseActive = document.querySelector(`#offer-${id}`);
            const collapsesHidden = document.querySelectorAll(".-question");
            const collapseParentActive = document.querySelector(
                `#offer-${id}`
            ).parentElement;

            collapsesHidden.forEach((element) => {
                if (!element.classList.contains("hidden"))
                    element.classList.add("hidden");
            });

            if (!collapseParentActive.classList.contains("active")) {
                collapseParentActive.classList.add("active");
                collapseActive.classList.remove("hidden");
            } else {
                collapseParentActive.classList.remove("active");
                collapseActive.classList.add("hidden");
            }
        },

        collapseCommandActive(id) {
            const collapseActive = document.querySelector(`#command-${id}`);
            const collapsesHidden = document.querySelectorAll(".-question");
            const collapseParentActive = document.querySelector(
                `#command-${id}`
            ).parentElement;

            collapsesHidden.forEach((element) => {
                if (!element.classList.contains("hidden"))
                    element.classList.add("hidden");
            });

            if (!collapseParentActive.classList.contains("active")) {
                collapseParentActive.classList.add("active");
                collapseActive.classList.remove("hidden");
            } else {
                collapseParentActive.classList.remove("active");
                collapseActive.classList.add("hidden");
            }
        },

        collapsePaymentActive(id) {
            const collapseActive = document.querySelector(`#payment-${id}`);
            const collapsesHidden = document.querySelectorAll(".-question");
            const collapseParentActive = document.querySelector(
                `#payment-${id}`
            ).parentElement;

            collapsesHidden.forEach((element) => {
                if (!element.classList.contains("hidden"))
                    element.classList.add("hidden");
            });

            if (!collapseParentActive.classList.contains("active")) {
                collapseParentActive.classList.add("active");
                collapseActive.classList.remove("hidden");
            } else {
                collapseParentActive.classList.remove("active");
                collapseActive.classList.add("hidden");
            }
        },
    },
};
</script>

<style lang="scss">



.-item {
    border: none;
    display: flex;
    flex-wrap: wrap;

    &.active {
        background: $wsmoke;
        border: none;
        margin-bottom: 1.6rem;

        .-answer {
            color: $black;
            display: block;
            flex-direction: initial;
            font-family: $f-nouvelR-regular;
            font-size: 1.6rem;
            line-height: 1.8rem;
            padding: 0 2.4rem 2.4rem;
            transition: none;

            a {
                color: $black;
                text-decoration: underline;
            }

            ul {
                li {
                    list-style: disc;
                }
            }
        }

        .-question {
            border: none;
            font-size: 30px;
            line-height: 28px;

            &::before {
                color: $black;
                content: "-";
                display: flex;
                font-size: 4rem;
                justify-content: flex-end;
                left: calc(100% - 4rem);
                position: absolute;
                transform: initial;
                transition: all 0.15s ease-in-out;
            }
        }
    }
}

.-question {
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: $black;
    cursor: pointer;
    display: flex;
    font-family: $f-nouvelR-extrabold;
    font-size: 20px;
    line-height: 22px;
    margin-bottom: 1.6rem;
    padding: 24px;
    position: relative;
    width: 100%;

    span {
        width: 95%;
    }

    .collapse-title {
        width: 90%;
    }

    &::before {
        color: $black;
        content: "+";
        display: flex;
        font-size: 2.5rem;
        justify-content: flex-end;
        left: calc(100% - 4rem);
        position: absolute;
        transform: initial;
        transition: all 0.15s ease-in-out;
    }
}

.-answer {
    display: none;
}

.title-containers {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-bottom: 6.4rem;

    .subtitle {
        color: #656666;
        font-family: $f-nouvelR-regular;
        font-size: 14px;
        letter-spacing: 3px;
        line-height: 120%;
    }

    .title {
        font-family: $f-nouvelR-extrabold;
        font-size: 40px;
        line-height: 80%;
        text-align: center;
        text-transform: uppercase;
    }
}

.faq-title {
    margin: 2rem;
}

.faq-container {
    margin: 8rem 1.6rem;

    @include teq-breakpoint($large) {
        margin: 8rem 19.5rem 6.4rem;
    }

    &.mt-160 {
        margin-top: 16rem;
    }

    h4 {
        margin-bottom: 2rem;
    }

    .slot-container {
        display: flex;
        justify-content: center;

        &:first-child {
            margin-top: 6.4rem;
        }
    }
}
</style>
